import React, { useEffect, useRef, useState } from 'react';
import { register } from 'swiper/element/bundle';
import TitleDecoration from "../elements/TitleDecoration";
import Image from "../elements/Image";
import Shadow from "../../assets/images/shadow.png";
import UserImage01 from "../../assets/images/image-user-01.webp";
import UserImage02 from "../../assets/images/image-user-02.webp";
import UserImage03 from "../../assets/images/image-user-03.webp";
import UserImage04 from "../../assets/images/image-user-04.webp";
import UserImage05 from "../../assets/images/image-user-05.webp";
import UserImage06 from "../../assets/images/image-user-06.webp";
import { classNames } from "../../helpers/classNames";
import Button from "../forms/Button";
register();

const HomeTestimonial = () => {
  const elementRef = useRef(null);
  const swiperElRef = useRef(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [elementWidth, setElementWidth] = useState(0);
  
  const data = [
    {
      _id: 1,
      color:"text-blue",
      name: "Sarah M.",
      image:UserImage01,
      parenting: "Mother of two",
      comment: "My children were so excited to color pictures from our family vacation! It's become a treasured keepsake."
    },
    
    {
      _id: 2,
      color:"text-red",
      name: "Emily K.",
      image:UserImage03,
      parenting: "Parent",
      comment: "The quality of the coloring pages is incredible! Perfect balance of detail and simplicity for my 5-year-old."
    },
    {
      _id: 3,
      color:"text-green",
      name: "Michael T.",
      image: UserImage02,
      parenting: "Father of three",
      comment: "My daughter loves having coloring pages with her own family in them. A wonderful way to engage with our memories."
    },
    {
      _id: 4,
      color:"text-yellow",
      name: "Sarah M.",
      image:UserImage05,
      parenting: "Mother of two",
      comment: "My children were so excited to color pictures from our family vacation! It's become a treasured keepsake."
    },
    {
      _id: 5,
      color:"text-purple",
      name: "Emily K.",
      image:UserImage06,
      parenting: "Parent",
      comment: "The quality of the coloring pages is incredible! Perfect balance of detail and simplicity for my 5-year-old."
    },
    {
      _id: 6,
      color:"text-orange",
      name: "Michael T.",
      image: UserImage04,
      parenting: "Father of three",
      comment: "My daughter loves having coloring pages with her own family in them. A wonderful way to engage with our memories."
    },
  ]

  useEffect(() => {
    const swiperEl = document.querySelector('swiper-container.testimonials');
    const swiperParams = {
      navigation: {
        nextEl: '.testimonials-control.swiper-button-next',
        prevEl: '.testimonials-control.swiper-button-prev',
      },
      slidesOffsetBefore:40,
      slidesOffsetAfter:40,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 0,
          centeredSlides: false,
          loop: true
        },
      },
      on: {
        init() { },
      },
    };
    Object.assign(swiperEl, swiperParams);
    swiperEl.initialize();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (elementRef.current) {
        setWidth(window.innerWidth);
        setElementWidth(elementRef.current.getBoundingClientRect().width);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const swiperWidth = (width - (elementWidth / 3)) - ((width - 1600) / 2);

  return (
    <>
      <section className="relative py-16 overflow-hidden bg-gradient-to-br from-dark-yellow via-yellow to-green z-[1]">
        <div ref={elementRef} className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-9xl mx-auto">
          <div className="flex items-center">
            <div className="relative w-1/3 flex-shrink-0">
              <div className="space-y-6 py-60 pr-20 relative">
                <div className="relative space-y-2">
                  <h2 className="font-BubblegumSans text-5xl">What Parents Say</h2>
                  <TitleDecoration classes={"!justify-start"} />
                </div>
                <div className="text-xl">Turn your cherished photos into coloring pages in just a few simple steps</div>
                <div className="absolute top-0 right-0 translate-x-full h-full !m-0">
                  <Image src={Shadow} alt={''} width={'100%'} height={'100%'} effect={'blur'} classes={'object-contain'} />
                </div>
              </div>
            </div>
            <div className="relative" style={{ width: swiperWidth }}>
              <swiper-container
                ref={swiperElRef}
                class="overflow-visible testimonials"
                init="false"
              >
                {data?.map((item) => (
                  <swiper-slide key={item._id} className="!h-auto flex p-4">
                    <div className="relative bg-white pt-16 pb-6 px-12 rounded-2xl shadow-lg flex flex-col justify-between gap-10 z-0">
                      <div className={classNames("absolute z-[-1] top-2 right-4 text-5xl", item?.color)}>
                        <i className="fa-solid fa-quote-right"></i>
                      </div>
                      <div className={classNames("absolute z-[-1] bottom-4 right-4 text-9xl opacity-5 -scale-x-100", item?.color)}>
                        <i className="fa-light fa-bullhorn -rotate-12"></i>
                      </div>
                      <div className="text-lg font-ShantellSans text-gray-700">{item?.comment}</div>
                      <div className="flex items-center gap-4">
                        <div className="w-12 aspect-square rounded-full overflow-hidden flex flex-shrink-0">
                          <Image src={item?.image} alt={''} width={'100%'} height={'100%'} effect={'blur'} classes={'object-cover'} />
                        </div>
                        <div className="flex-shrink">
                          <div className="text-base font-ShantellSans font-semibold text-black">{item?.name}</div>
                          <div className="text-sm text-gray-400 tracking-wide">{item?.parenting}</div>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                ))}
              </swiper-container>
              <div className="flex relative justify-center lg:justify-start lg:left-14 mt-8 gap-2">
                <Button
                  buttonClasses={'!relative !top-auto !bottom-auto !left-auto !right-auto !m-0 !w-auto bg-gradient-to-tr from-orange to-red !h-8 !px-2 !rounded-lg testimonials-control swiper-button-prev after:content-[""] !gap-0'}
                  buttonType={'submit'}
                  buttonLabel={''}
                  buttonLabelClasses={''}
                  buttonIcon={"fa-regular fa-arrow-left-long"}
                  buttonIconPosition={"left"}
                />
                <Button
                  buttonClasses={'!relative !top-auto !bottom-auto !left-auto !right-auto !m-0 !w-auto bg-gradient-to-tr from-orange to-red !h-8 !px-2 !rounded-lg testimonials-control swiper-button-next after:content-[""] !gap-0'}
                  buttonType={'submit'}
                  buttonLabel={''}
                  buttonLabelClasses={''}
                  buttonIcon={"fa-regular fa-arrow-right-long"}
                  buttonIconPosition={"left"}
                />
              </div>
            </div>
          </div>
          
        </div>
      </section>
      
    </>
  );
};

export default HomeTestimonial;